export const AppVersion = '3.17.0';

export enum ENVIRONMENT {
  ITG = 'itg',
  LOCAL = 'local',
  LOCAL_MOCKS = 'local.mocks'
}
